<template>
    <!-- 司机-司机分数 -->
    <div class="container container-tabs">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">司机姓名:</span>
                    <el-input
                        v-model="search_data.real_name"
                        placeholder="司机姓名"
                        @keyup.enter.native="searchDriverPointsLists"
                        class="handle-input mr10"
                    ></el-input>
                </el-col>

                <el-col :span="12">
                    <span class="title">手机号:</span>
                    <el-input
                        v-model="search_data.phone"
                        placeholder="请输入手机号"
                        maxlength="11"
                        @keyup.enter.native="searchDriverPointsLists"
                        class="handle-input mr10"
                    ></el-input>
                </el-col>

            </el-row>
            <el-row class="head-search" style="margin-left: 20px;">
                <el-col :span="24">
                    <el-radio-group v-model="search_data.driver_capacity">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button v-for="(item,index) in result_data.data.driver_capacity_conf"
                            :label="index"
                            :key="index">

                            {{ item.alias }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>

            </el-row>
            <el-row class="head-search" style="margin-left: 20px;">
                <el-col :span="24">
                    <el-radio-group v-model="search_data.driver_sign_type">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button :label="index" v-for="(item,index) in result_data.data.driver_sign_type"
                        :key="index">{{ item }}</el-radio-button>
                    </el-radio-group>
                </el-col>

            </el-row>

            <el-row class="head-search" style="margin-left: 20px;">
                <el-col :span="24">
                    <el-radio-group v-model="search_data.status">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button :label="item.val" v-for="(item,index) in status_list"
                        :key="index">{{ item.alias }}</el-radio-button>
                    </el-radio-group>
                </el-col>

            </el-row>

            <el-row class="head-search" style="margin-left: 20px;">

                <el-col :span="24">
                    <el-radio-group v-model="search_data.order_by">
                        <el-radio-button label="ASC">表现分正序</el-radio-button>
                        <el-radio-button label="DESC">表现分倒序</el-radio-button>
                    </el-radio-group>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchDriverPointsLists">搜索</el-button>
            <!-- <el-button @click="add_isShow = !add_isShow">添加</el-button> -->
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show"
                >{{ progress_show ? '导出中...' : '导出' }}
            </el-button>
        </div>

        <!-- 表格 -->
        <!-- 活动积分，表现分，综合分，段位，职位，签约类型 -->
        <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="real_name" label="司机姓名"> </el-table-column>
            <el-table-column prop="phone" label="司机电话"> </el-table-column>
            <el-table-column prop="star_point" label="乘客评星"> </el-table-column>

            <el-table-column prop="activity_point" label="活动积分"> </el-table-column>

            <el-table-column prop="monitor_point" label="表现分"> </el-table-column>

            <el-table-column prop="dan" label="司机段位"> </el-table-column>

            <el-table-column prop="capacity" label="司机职位"> </el-table-column>
            <el-table-column prop="signing_type" label="司机类型"> </el-table-column>

            <!-- <el-table-column prop="exponent_points" label="综合分"> </el-table-column> -->
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
var _this;
export default {
    data() {
        return {
            progress_show: false,
            excelData: [],


            tableLoading: false,

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                phone: '',
                order_by:'ASC',
                driver_capacity:'',
                driver_sign_type:'',
                real_name: '',
                status: '',
            },

            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            status_list: [
                {
                    "val": 4,
                    "alias": "逾期"
                },
                {
                    "val": 3,
                    "alias": "解约"
                },
                {
                    "val": 2,
                    "alias": "封禁"
                },
                {
                    "val": 1,
                    "alias": "有效"
                },
                {
                    "val": 0,
                    "alias": "待激活"
                }
            ]
        };
    },
    created() {
        _this = this;
        _this.searchDriverPointsLists();
    },

    methods: {
        toExport() {
            _this.progress_show = true;

            _this.search_data.page = 1;

            // console.log(11);
            _this.getExcelData();
        },
        getExcelData() {
            // console.log(22);
            _this.search_data.is_export = "1";
            _this
                .$post('/driver/driverPointsLists', _this.search_data)
                .then((res) => {
                    console.log(3);

                    if (this.$route.path == '/driverPoints') {
                        // 导出excel的空数组中添加数据
                        console.log(res.data.result);
                        for (let i = 0; i < res.data.result.length; i++) {

                            _this.excelData.push({
                                real_name: res.data.result[i].real_name,
                                phone: res.data.result[i].phone,
                                star_point: res.data.result[i].star_point,
                                activity_point: res.data.result[i].activity_point,
                                monitor_point: res.data.result[i].monitor_point,
                                dan: res.data.result[i].dan,
                                capacity: res.data.result[i].capacity,
                                signing_type: res.data.result[i].signing_type,
                                exponent_points: res.data.result[i].exponent_points,
                                status: _this.status_list.find(item => item.val == _this.search_data.status).alias,
                            });
                        }
                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;
                            _this.getExcelData();
                            console.log(555);
                        } else {
                            console.log(444);
                            // 将数据导出execl
                            _this.exportData();
                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];
                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            // const tHeader = ['司机姓名',  '在线时长', '单量', '销单', '收入'];
            // const tHeader = ['司机姓名', '司机电话', '乘客评星', '活动积分','表现分', '司机段位', '司机职位', '司机类型','综合分', '状态'];
            const tHeader = ['司机姓名', '司机电话', '乘客评星', '活动积分','表现分', '司机段位', '司机职位', '司机类型', '状态'];
            // const filterVal = ['real_name', 'phone', 'star_point', 'activity_point','monitor_point', 'dan', 'capacity', 'signing_type','exponent_points','status'];
            const filterVal = ['real_name', 'phone', 'star_point', 'activity_point','monitor_point', 'dan', 'capacity', 'signing_type', 'status'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        searchDriverPointsLists() {
            _this.search_data.page = 1;
            _this.driverPointsLists();
        },

        // 搜索列表
        driverPointsLists() {
            _this.tableLoading = true;
            _this
                .$post('/driver/driverPointsLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableLoading = false;

                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data.result;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverPointsLists();
        },
        handleSizeChange(val) {
            _this.search_data.limit = val;
            _this.driverPointsLists();
        },
        handleCurrentChange(val) {
            _this.search_data.page = val;
            _this.driverPointsLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}
</style>
